import React from 'react'
import { ReportDesigner } from './reportDesignerAsync'
import { useLocalization } from '@/hooks/localization'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'

const ReportDesignerPage = React.memo(function ReportDesignerPage () {
  const { localize } = useLocalization()
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          {localize('ReportDesigner.PageTitle')}
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <ReportDesigner />
      </MainBody>
    </Main>
  )
})

export {
  ReportDesignerPage
}



// WEBPACK FOOTER //
// ./src/components/reportDesigner/page.js